export default {
  DEFAULT: 'DEFAULT',
  GATES: 'GATES',
  LOCK: 'LOCK',
  SWITCH: 'SWITCH',
  T_WIRE: 'T_WIRE',
  T_WIREx4: 'T_WIREx4',
  THERMOMETER: 'THERMOMETER',
};
